import { FC, useMemo } from 'react';
import { cn } from 'src/utils/utility';
import { CardTheme } from './cardAnalytic/types';

interface ICardWorkflowProps {
  label: string;
  value: string;
  icon: string;
  theme: CardTheme;
}

export const CardWorkflow: FC<ICardWorkflowProps> = (props) => {
  const { label, value, icon, theme } = props;

  const iconBgColor = useMemo(() => {
    switch (theme) {
      case CardTheme.NEUTRAL:
        return 'bg-[#E9EBF1]';
      case CardTheme.ORANGE:
        return 'bg-[#FEF3E5]';
      case CardTheme.GREEN:
        return 'bg-[#E0F3E6]';
      case CardTheme.BLUE:
        return 'bg-[#E9EFFE]';
      case CardTheme.BLUE_LIGHT:
        return 'bg-[#EBF3FF]';
      case CardTheme.PURPLE:
        return 'bg-[#EEE5F2]';
      case CardTheme.PURPLE_LIGHT:
        return 'bg-[#F9EEFE]';
      case CardTheme.PINK:
        return 'bg-[#FAE4F6]';
      case CardTheme.RED:
        return 'bg-[#FCE5E9]';
      default:
        return 'bg-neutral-10';
    }
  }, [theme]);

  return (
    <div
      className={cn(
        'relative overflow-hidden bg-white border border-b-[3px] border-[#D3D7DF] rounded-10 shadow-[0_2px_0px_0_rgba(112,149,221,0.12)] w-full px-16 py-[28px] flex items-center gap-16',
        'transition-all duration-300'
      )}
    >
      <div className='flex items-center justify-between'>
        <div className={cn('w-[44px] h-[44px] rounded-full flex items-center justify-center', iconBgColor)}>
          <img src={icon} alt='' className='w-24' />
        </div>
      </div>
      <div className='flex-1 text-left'>
        <h4 className={cn('text-base xl:text-xl font-bold', 'text-blue_grey-90')}>{value}</h4>
        <p className={cn('text-[10px] xl:text-12', 'text-neutral-60')}>{label}</p>
      </div>
    </div>
  );
};
